module.exports = __webpack_public_path__ + "static/media/1011896708-preview.f7f78b90.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/1011896708-preview.mp4
// module id = 1812
// module chunks = 0